import type { SVGProps } from 'react';
const DawnFlagAN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-AN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-AN_svg__a)">
      <path fill="#D6182D" d="M8.381 0h5.238v16H8.381z" />
      <path fill="#1425A2" d="M0 5.333h22v5.333H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m8.905 9.333-.37.11.108-.376-.109-.377.37.11.371-.11-.108.377.108.377zM13.095 9.333l-.37.11.108-.376-.108-.377.37.11.37-.11-.108.377.109.377zM6.81 8.267l-.37.11L6.548 8l-.108-.377.37.11.37-.11L7.072 8l.108.377zM15.19 8.267l-.37.11L14.93 8l-.109-.377.37.11.371-.11-.108.377.108.377zM11 7.2l-.37.11.108-.377-.108-.377.37.11.37-.11-.108.377.109.377z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagAN;
